<div class="report-select">
  <h2 mat-dialog-title>Report selection</h2>
  <mat-dialog-content>
    <form [formGroup]="form">
      <mat-form-field>
        <mat-label>Select the report</mat-label>
        <mat-select formControlName="reportLayout">
          <mat-option *ngFor="let layout of layouts$ | async" [value]="layout">
            {{ layout.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!form.valid" (click)="add()">Add</button>
  </mat-dialog-actions>
</div>
